import { render, staticRenderFns } from "./PatentResponsibleList.vue?vue&type=template&id=811684c4&"
import script from "./PatentResponsibleList.vue?vue&type=script&lang=js&"
export * from "./PatentResponsibleList.vue?vue&type=script&lang=js&"
import style0 from "./PatentResponsibleList.vue?vue&type=style&index=0&id=811684c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports